import { useTranslation } from 'react-i18next';
import { cn } from '@/shared/utils';
import { applyAmountPrecision, formatReceivedAmount } from '@/shared/lib';
import { NUMERIC_CONFIG } from '@/shared/config';

interface CommissionData {
  feeAmount: number;
  currencyCode: string;
  receiveAmount: number;
}

interface ServiceFeeDisplayProps {
  commissionData?: CommissionData;
  className?: string;
  text?: string;
}

export function ServiceFeeDisplay({
  commissionData,
  className,
  text,
}: ServiceFeeDisplayProps) {
  const { t } = useTranslation();

  if (!commissionData) {
    return null;
  }

  const precision = NUMERIC_CONFIG.precision.default;
  const { feeAmount, currencyCode, receiveAmount } = commissionData;

  const roundedReceiveAmount = applyAmountPrecision(
    receiveAmount,
    precision,
    'credit'
  );

  return (
    <div className={cn('p5 text-muted-foreground', className)}>
      {text ||
        t('common.serviceFee', {
          feeAmount: formatReceivedAmount(feeAmount),
          currencyCode,
          receiveAmount: formatReceivedAmount(roundedReceiveAmount),
        })}
    </div>
  );
}
